import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Box, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MailOutlinedIcon from "../../../assets/icons/MailOutlinedIcon";
import InlineIconButton from "../InlineIconButton/InlineIconButton";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";

export default function EmailButton({ email, disabled, color }) {
  const [copied, setCopied] = useState(false);
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
  const timerRef = useRef(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setCopyTooltipOpen(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setCopied(false);
      setCopyTooltipOpen(false);
    }, 2000);
  };

  const handleCopyTooltipOpen = () => { if (!disabled) setCopyTooltipOpen(true); };
  const handleCopyTooltipClose = () => {
    if (!copied) setCopyTooltipOpen(false);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ marginRight: "4px" }}>
        <a style={{ textDecoration: "none", ...(disabled && { pointerEvents: "none" }) }} href={`mailto:${email}`}>
          <StyledTooltip title={disabled ? "" : email || ""}>
            <Box>
              <InlineIconButton
                icon={MailOutlinedIcon}
                disabled={disabled}
                buttonColor={color}
              />
            </Box>
          </StyledTooltip>
        </a>
      </Box>
      <Tooltip
        title={<Typography variant="body1">{copied ? "Copied!" : email}</Typography>}
        open={copyTooltipOpen}
        onOpen={handleCopyTooltipOpen}
        onClose={handleCopyTooltipClose}
        enterDelay={200}
        enterNextDelay={200}
        placement="bottom-start"
        arrow
      >
        <Box>
          <InlineIconButton
            icon={ContentCopyIcon}
            disabled={disabled}
            buttonColor={color}
            onClick={handleCopy}
          />
        </Box>
      </Tooltip>
    </Box>
  );
}

EmailButton.propTypes = {
  email: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};
